module.exports = __webpack_public_path__ + "img/tank-follow.f2729eb4.jpg";